"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const config_1 = require("@nestjs/config");
const typeorm_1 = require("@nestjs/typeorm");
// Config
const database_config_1 = require("../config/database.config");
// Auth
const auth_module_1 = require("../modules/auth/auth.module");
const authorization_module_1 = require("../modules/authorization/authorization.module");
// Feature Modules
const customers_module_1 = require("../modules/customers/customers.module");
const orders_module_1 = require("../modules/orders/orders.module");
const products_module_1 = require("../modules/products/products.module");
const inventory_module_1 = require("../modules/inventory/inventory.module");
const tickets_module_1 = require("../modules/tickets/tickets.module");
const feedback_module_1 = require("../modules/feedback/feedback.module");
const refunds_module_1 = require("../modules/refunds/refunds.module");
const medical_history_module_1 = require("../modules/medical-history/medical-history.module");
const consultation_module_1 = require("../modules/consultation/consultation.module");
const notifications_module_1 = require("../modules/notifications/notifications.module");
const webhooks_module_1 = require("../modules/webhooks/webhooks.module");
const users_module_1 = require("../modules/users/users.module");
const dashboard_module_1 = require("../modules/dashboard/dashboard.module");
let AppModule = class AppModule {
};
exports.AppModule = AppModule;
exports.AppModule = AppModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [
            config_1.ConfigModule.forRoot({ isGlobal: true }),
            typeorm_1.TypeOrmModule.forRoot((0, database_config_1.databaseConfig)()),
            authorization_module_1.AuthorizationModule,
            // Auth (must come first)
            auth_module_1.AuthModule,
            // Feature modules
            customers_module_1.CustomersModule,
            orders_module_1.OrdersModule,
            products_module_1.ProductsModule,
            inventory_module_1.InventoryModule,
            tickets_module_1.TicketsModule,
            feedback_module_1.FeedbackModule,
            refunds_module_1.RefundsModule,
            medical_history_module_1.MedicalHistoryModule,
            consultation_module_1.ConsultationModule,
            notifications_module_1.NotificationsModule,
            webhooks_module_1.WebhooksModule,
            users_module_1.UsersModule,
            dashboard_module_1.DashboardModule,
        ],
        providers: [],
    })
], AppModule);
